export const XpDots = ({
  color,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const fill = color ?? 'url(#gradient)';

  return (
    <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5.5" cy="8.5" r="2.5" fill={fill}/>
      <circle cx="19" cy="2" r="2" fill={fill}/>
      <circle cx="36.5" cy="11.5" r="2.5" fill={fill}/>
      <circle cx="34" cy="28" r="2" fill={fill}/>
      <circle cx="19.5" cy="36.5" r="2.5" fill={fill}/>
      <circle cx="2" cy="27" r="2" fill={fill}/>
      <defs>
        <linearGradient id="gradient" x1="5.5" y1="6" x2="5.5" y2="11" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4E10FF"/>
        <stop offset="1" stopColor="#AB17DF"/>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default XpDots
